import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Fire a GA4 page_view on every React Router navigation.
 * Mount once inside <BrowserRouter>. Initial load is already covered by
 * gtag('config', ..., { send_page_view: true }) in index.html, but SPA
 * navigations are not — this fills that gap.
 */
export const RouteAnalytics = () => {
  const location = useLocation();
  useEffect(() => {
    // tiny defer so document.title is updated by the route's <SeoHead>
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 30);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
};

export default RouteAnalytics;
